import {Component, Input, OnInit} from '@angular/core';
import {AssistantDefinition} from '../../services/ai-assistant.service';

@Component({
  selector: 'app-assistant-profile',
  templateUrl: './assistant-profile.component.html',
  styleUrls: ['./assistant-profile.component.scss']
})
export class AssistantProfileComponent implements OnInit {
  @Input() assistant: AssistantDefinition;

  constructor() {
  }

  get image() {
    return this.assistant.image;
  }

  get name() {
    return this.assistant.name;
  }

  get description() {
    return this.assistant.description;
  }

  get role() {
    return this.assistant.role;
  }

  ngOnInit(): void {
  }

}
